import Base from "./Base";
import MapCommon from "../../common/MapCommon";
import DrawArea from "./DrawArea";
import SelectPolygon from "./SelectPolygon";
import {TOOL_CULLING} from "./ToolType";

export default class DeductTool extends Base{
  constructor(options = {}) {
    let params={
      map:null,//地图实例
      showIcon: true,//是否展示图标
      iconCLassName: "iconfont-map map-icon-kouchu",//图标类名
      callBackName: "",//正常地图事件回调
      errorEventName: "",//错误地图事件回调
      chineseName: "抠除",//中文工具名称
      checkValid:false,//是否检测自相交
      showArea:false,//是否实时展示面积
      callBack:null,
      errorCallBack:null,
      clickLayers:[],//点选目标图层id
      features:[],//需要展示到点选图层的要素
      clickLayersFilters:[],//点击图层过滤器
      stopLayers:[],//遮挡图层id
      showTool:false,//是否展示撤销工具条
      toolPosition:'top-right',//工具条位置,'top-left' ， 'top-right' ， 'bottom-left' ，和 'bottom-right' 。默认为 'top-right' 。
      circleRadius: 7,
      showLength:false,
      circleStrokeWidth:2,
    }
    Object.assign(params,options)
    super(params.map, TOOL_CULLING, params);
    this.showArea=params.showArea;
    this.checkValid=params.checkValid;
    this.clickLayersFilters=params.clickLayersFilters;
    this.stopLayers=params.stopLayers;
    this.params=params;

  }

  start(){
    super.start();
    this.tempLayerId=""
    if(this.params.features&&this.params.features.length>0){//已有多边形，直接绘制然后分割
      this._startDrawArea();
      this.curPolygon=this.params.features[0];
      this.tempLayerId=MapCommon.addHighLightPolygon(this.map,this.curPolygon)

    }else {
      this._startSelectPolygon();
    }

  }
  _startSelectPolygon(){
    //需要点选的情况，增加点选图层
    this.selectControl=new SelectPolygon({
      map:this.map,
      continueSelect:true,
      clickLayers:this.params.clickLayers,
      showIcon:false,
      clickLayersFilters:this.params.clickLayersFilters,//点击图层过滤器
      stopLayers:this.params.stopLayers,//遮挡图层id
      callBack:(res)=>{
        console.log(res)//绘制成功回调
        this.selectControl.close();
        this.selectControl=null;
        this.curPolygon=res.features[0];
        this.tempLayerId=MapCommon.addHighLightPolygon(this.map,res);
        this._startDrawArea();
      }
    });
    this.selectControl.start();
  }


  _startDrawArea(){
    this.drawAreaControl=new DrawArea({
      map:this.map,
      showIcon:false,
      innerUse:true,
      showArea: this.params.showArea,
      showLength: this.params.showLength,
      checkValid: true,
      showTool:this.params.showTool,
      toolPosition:this.params.toolPosition,
      continueDraw:false,
      circleRadius:this.params.circleRadius,
      circleStrokeWidth:this.params.circleStrokeWidth,

      callBack:(e)=>{
        console.log("绘制完成",e)
        this.drawAreaControl.close();
        this.drawAreaControl=null;
        this._deduct(e);
      },
    })
    this.drawAreaControl.start();
  }
  _deduct(mask){
    let res=MapCommon.deductPolygon(this.curPolygon,mask);
    this.finish(res);
  }

  close(notClearMap=false) {
    this.clear(notClearMap);
    this.clearEvent();
  }

  clear(notClearMap=false) {
    //移除线绘制
    if(this.drawAreaControl){
      this.drawAreaControl.close();
      this.drawAreaControl=null;
    }
    if(this.selectControl){
      this.selectControl.close();
      this.selectControl=null;
    }

    this.clearMap(notClearMap);
  }

  clearMap(notClearMap=false) {
    //不清除地图选择绘制图层
    if(!notClearMap){
      super.clearMap();
    }
    if(this.tempLayerId){
      MapCommon.removeLayerAndSource(this.map,this.tempLayerId)
    }
  }

  clearEvent() {
    super.clearEvent();
    this.clickLayers=[];
  }
}



// WEBPACK FOOTER //
// ./src/tool/edit/DeductTool.js